import React, { useState, useEffect, useContext } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Alert from "@mui/material/Alert";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress"; // ✅ Added
import axios from "axios";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import Autocomplete from "@mui/material/Autocomplete";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DownloadExcelButton from "components/ReportUI/Downloadexcelbutton";
import MDSnackbar from "components/MDSnackbar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { AccountsContext } from "context/AccountsContext";
import { geofenceReportEndpiont } from "config";
import GeofenceReportsTable from "./geofenceReportTable";

function GeofenceReport() {
  const [reportData, setReportData] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);
  const [vehicleIds, setVehicleIds] = useState([]);
  const [loading, setLoading] = useState(false); // ✅ Loading state
  const { fetchThings, things } = useContext(AccountsContext);

  useEffect(() => {
    fetchThings();
  }, []);

  const today = new Date();
  const startTimeDefault = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
  const endTimeDefault = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59);

  const [startTime, setStartTime] = useState(startTimeDefault);
  const [endTime, setEndTime] = useState(endTimeDefault);

  // Snackbar handlers
  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);

  // Columns for DataTable
  const columns = [
    { Header: "Date", accessor: "dateRange", width: "10%" },
    { Header: "Vehicle Number", accessor: "thingId", width: "15%" },
    { Header: "Vehicle Name", accessor: "thingName", width: "15%" },
    { Header: "Geofence Name", accessor: "fenceName", width: "20%" },
    { Header: "Entry Time", accessor: "entryTime", width: "10%" },
    { Header: "Exit Time", accessor: "exitTime", width: "10%" },
    { Header: "Time Inside (Hr:Min:Sec)", accessor: "timeInsideFormatted", width: "20%" },
  ];

  const formatTime = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
    const seconds = String(totalSeconds % 60).padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
  };

  const fetchReport = async () => {
    const token = localStorage.getItem("token");
    setLoading(true); // ✅ Start loading
    setErrorMessage("");

    const formatDateTime = (d) => {
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    };

    const formatDate = (d) => {
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())}`;
    };

    try {
      const data = {
        startTime: formatDateTime(startTime),
        endTime: formatDateTime(endTime),
        zone: "Asia/Kolkata",
        things: vehicleIds.join(","),
        thingIds: vehicleIds,
        date: formatDate(startTime),
      };

      const config = {
        method: "post",
        url: geofenceReportEndpiont,
        headers: {
          "x-dhundhoo-session": token,
          "Content-Type": "application/json",
        },
        data,
      };

      const response = await axios.request(config);

      const formattedRows = response.data.map((log) => ({
        dateRange: log.dateRange,
        thingId: log.thingId,
        thingName: log.thingName,
        fenceName: log.fenceName,
        entryTime: log.entryTime,
        exitTime: log.exitTime,
        timeInsideFormatted: formatTime(log.timeInside),
      }));

      setReportData(formattedRows);
      openSuccessSB();
    } catch (error) {
      console.error(error);
      setErrorMessage("Error loading geofence report");
      openErrorSB();
    } finally {
      setLoading(false); // ✅ Stop loading
    }
  };

  const exportToCSV = () => {
    if (reportData.length === 0) {
      setErrorMessage("No data to export");
      openErrorSB();
      return;
    }
    const headers = ["Date", "Vehicle Number", "Vehicle Name", "Geofence Name", "Entry Time", "Exit Time", "Time Inside"];
    const rows = reportData.map((row) =>
      [row.dateRange, row.thingId, row.thingName, row.fenceName, row.entryTime, row.exitTime, row.timeInsideFormatted].join(",")
    );
    const csvContent = [headers.join(","), ...rows].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `GeofenceReport.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
// Inside GeofenceReport component

const clearFilters = () => {
    setVehicleIds([]);
    setReportData([]);
    setErrorMessage("");
    setStartTime(startTimeDefault);
    setEndTime(endTimeDefault);
  };
  
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox p={3} pb={0}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Grid container spacing={2}>
                    {/* Vehicle Multi-Select */}
                    <Grid item xs={12} sm={6} md={3}>
                      <Autocomplete
                        multiple
                        options={things || []}
                        getOptionLabel={(option) => option.thingId}
                        value={things.filter((t) => vehicleIds.includes(t.thingId))}
                        onChange={(event, newValue) => {
                          setVehicleIds(newValue.map((v) => v.thingId));
                        }}
                        renderOption={(props, option) => (
                          <li {...props} style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                            <span>{option.nickName}</span>
                            <span style={{ color: "#666" }}>{option.thingId}</span>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField {...params} placeholder="Select Vehicles" fullWidth size="small" />
                        )}
                      />
                    </Grid>

                    {/* Start Time */}
                    <Grid item xs={12} sm={6} md={3}>
                      <DateTimePicker
                        ampm={false}
                        label="Start Time"
                        value={startTime}
                        onChange={(newValue) => setStartTime(newValue)}
                        renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                      />
                    </Grid>

                    {/* End Time */}
                    <Grid item xs={12} sm={6} md={3}>
                      <DateTimePicker
                        ampm={false}
                        label="End Time"
                        value={endTime}
                        onChange={(newValue) => setEndTime(newValue)}
                        renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                      />
                    </Grid>

                   
<Grid item xs={4} sm={2} md={1}>
  <MDButton fullWidth variant="gradient" color="info" size="small" onClick={fetchReport} disabled={loading}>
    {loading ? <CircularProgress size={20} color="inherit" /> : "LOAD"}
  </MDButton>
</Grid>

<Grid item xs={4} sm={2} md={1}>
  <DownloadExcelButton fullWidth label="CSV" onClick={exportToCSV} disabled={loading} />
</Grid>

<Grid item xs={4} sm={2} md={1}>
  <MDButton fullWidth variant="outlined" color="error" size="small" onClick={clearFilters} disabled={loading}>
    CLEAR
  </MDButton>
</Grid>

                  </Grid>
                </LocalizationProvider>
              </MDBox>

              {/* Error Alert */}
              {errorMessage && (
                <MDBox px={2} pt={2}>
                  <Alert severity="error">{errorMessage}</Alert>
                </MDBox>
              )}

              {/* Loader or Table */}
              <MDBox pt={3} display="flex" justifyContent="center">
                {loading ? (
                  <CircularProgress /> // ✅ Show center loader
                ) : (
                  <GeofenceReportsTable
                    table={{ columns, rows: reportData }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={true}
                    noEndBorder
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <MDSnackbar color="success" icon="check" title="Geofence Report" content="Data Loaded Successfully" open={successSB} onClose={closeSuccessSB} close={closeSuccessSB} bgWhite />
      <MDSnackbar color="error" icon="warning" title="Geofence Report" content="Failed to load report" open={errorSB} onClose={closeErrorSB} close={closeErrorSB} bgWhite />
    </DashboardLayout>
  );
}

export default GeofenceReport;




